<template>
    <v-dialog :persistent="true" max-width="500px" v-model="inDialog">
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                            }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                            @click="onCancel"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>

                <v-card-text>
                    <v-layout wrap>
                        
                        <!-- <v-flex xs12>
                            <v-text-field
                                    :data-vv-as="$t('Tên quy trình')"
                                    :error-messages="errors.first('name')"
                                    :label="$t('Tên quy trình')"
                                    maxLength="250"
                                    name="name"
                                    type="text"
                                    v-model.trim="item.name"
                                    v-validate="'required'"
                            ></v-text-field>
                        </v-flex> -->
                        <v-flex xs12>
                            <v-select
                                    :data-vv-as="$t('Khu nuôi')"
                                    :error-messages="errors.first('areaId')"
                                    :items="areas"
                                    :label="$t('Khu nuôi')"
                                    item-text="categoryCode"
                                    item-value="categoryId"
                                    name="areaId"
                                    v-model="item.areaId"
                                    v-validate="'required'"
                                    v-on:change="areaChange()"
                                      :disabled="item.isEditForm"
                            />

                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                    :data-vv-as="$t('Số lượng giống')"
                                    :error-messages="errors.first('seedNumber')"
                                    :items="seedNumbers"
                                    :label="$t('Số lượng giống')"
                                    item-text="categoryName"
                                    item-value="categoryName"
                                    name="seedNumber"
                                    v-model="item.seedNumber"
                                    v-validate="'required'"
                                    v-on:change="seedNumberChange()"
                                    :disabled="item.isEditForm"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    :data-vv-as="$t('Mã quy trình')"
                                    :error-messages="errors.first('code')"
                                    :label="$t('Mã quy trình')"
                                    maxLength="250"
                                    name="code"
                                    type="text"
                                    v-model.trim="item.code"
                                    v-validate="'required'"
                                    disabled
                            ></v-text-field>
                        </v-flex>
                      <v-flex xs12>
                        <v-text-field
                            :data-vv-as="$t('Ghi chú')"
                            :error-messages="errors.first('note')"
                            :label="$t('Ghi chú')"
                            maxLength="250"
                            name="note"
                            type="text"
                            v-model.trim="item.note"
                            v-validate="'required'"
                        ></v-text-field>
                      </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    :data-vv-as="$t('lang.procedureWh.feedDay')"
                                    :error-messages="errors.first('feedDay')"
                                    :label="$t('lang.procedureWh.feedDay')"
                                    maxLength="500"
                                    name="feedDay"
                                    ref="feedDay"
                                    id="feedDay"
                                    type="number"
                                    v-model.trim="item.feedDay"
                                    v-validate="'required|max_value:500'"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    :data-vv-as="$t('lang.procedureWh.shrimpReleaseDay')"
                                    :error-messages="errors.first('shrimpReleaseDay')"
                                    :label="$t('lang.procedureWh.shrimpReleaseDay')"
                                    maxLength="500"
                                    name="shrimpReleaseDay"
                                    ref="shrimpReleaseDay"
                                    type="number"
                                    v-model.trim="item.shrimpReleaseDay"
                                    v-validate="'required'"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    :data-vv-as="$t('lang.procedureWh.pondTreatmentDay')"
                                    :error-messages="errors.first('pondTreatmentDay')"
                                    :label="$t('lang.procedureWh.pondTreatmentDay')"
                                    maxLength="500"
                                    name="pondTreatmentDay"
                                    ref="pondTreatmentDay"
                                    type="number"
                                    v-model.trim="item.pondTreatmentDay"
                                    v-validate="'required'"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field
                                    :data-vv-as="$t('lang.procedureWh.shrimpTransferDay')"
                                    :error-messages="errors.first('shrimpTransferDay')"
                                    :label="$t('lang.procedureWh.shrimpTransferDay')"
                                    maxLength="500"
                                    name="shrimpTransferDay"
                                    ref="shrimpTransferDay"
                                    type="number"
                                    v-model.trim="item.shrimpTransferDay"
                                    v-validate="'required'"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <v-select
                                    :data-vv-as="$t('Trạng thái')"
                                    :error-messages="errors.first('status')"
                                    :items="areaStatus"
                                    :label="$t('Trạng thái')"
                                    item-text="text"
                                    item-value="value"
                                    name="status"
                                    v-model="item.status"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <!-- </v-container> -->
            </v-form>
            <div style="text-align: right">
                <v-btn @click="onSave" color="primary">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn @click="onCancel" color="error">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import {message} from "../../../services";
    import axios from "axios";
    import {areaContants} from "@/constants";
    export default {
        name: "procedure-wh-create",
        components: {message, axios},
        props: {
            propsItem: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            cDialog: {
                type: Boolean,
                default: false,
            },
            areas: {
                type: Array,
                default: [],
            },
            seedNumbers : {
                type: Array,
                default: [],
            },
            formCreateName: {
                type: String,
                default: '',
            },
        },
        data: () => {
            return {
                //formName: "Cập nhật quy trình",
                areaStatus: areaContants.areaStatus,
                item: {
                    status: 1,
                },
                inDialog: false,
                currentCode: "",
            };
        },
        watch: {
            propsItem: {
                handler(value) {
                    console.log("propsItem 123");
                  console.log(value)
                    if (value !== null) {
                        this.item = Object.assign({}, value)
                        this.currentCode= value.code;
                    } else {
                        this.resetFrom();
                      this.currentCode= "";
                    }
                },
                deep: true,
            },
            cDialog(value) {
                this.inDialog = value;
            },
            inDialog(value) {
                if (!value) {
                    this.$emit("closeDialog", "");
                }
            },
        },
        methods: {
            resetFrom: function () {
                this.item = {
                    // code: "",
                    // name: "",
                    // areaId: "0",
                    status: 1,
                };
            },
            onCancel: function () {
                this.$emit("closeDialog", "");
            },
            onSave: function () {
                // console.log(this.item);
                this.$validator.validate().then((valid) => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                   // alert(this.item.shrimpReleaseDay)
                    if(parseInt(this.item.shrimpReleaseDay) >= parseInt(this.item.feedDay)){
                        message.error(this.$t("lang.common.lower", {0: this.$t("lang.procedureWh.shrimpReleaseDay"), 1: this.$t("lang.procedureWh.feedDay")}));
                        this.$refs.shrimpReleaseDay.focus()
                        return;
                    }
                    if(parseInt(this.item.shrimpReleaseDay) >= parseInt(this.item.pondTreatmentDay)){
                        message.error(this.$t("lang.common.lower", {0: this.$t("lang.procedureWh.shrimpReleaseDay"), 1: this.$t("lang.procedureWh.pondTreatmentDay")}));
                        this.$refs.pondTreatmentDay.focus()
                        return;
                    }
                    if(parseInt(this.item.pondTreatmentDay) >= parseInt(this.item.shrimpTransferDay)){
                        message.error(this.$t("lang.common.lower", {0: this.$t("lang.procedureWh.pondTreatmentDay"), 1: this.$t("lang.procedureWh.shrimpTransferDay")}));
                        this.$refs.shrimpTransferDay.focus()
                        return;
                    }
                    if(parseInt(this.item.shrimpTransferDay) >= parseInt(this.item.feedDay)){
                        message.error(this.$t("lang.common.lower", {0: this.$t("lang.procedureWh.shrimpTransferDay"), 1: this.$t("lang.procedureWh.feedDay")}));
                        this.$refs.shrimpTransferDay.focus()
                        return;
                    }
                    axios.post(
                        process.env.VUE_APP_API_URL +
                        "/procedureWh/save",
                        this.item
                    ).then(
                        (data) => {
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
                });
            },
            areaChange() {
                this.getNextCode();
            },
            seedNumberChange() {
                this.getNextCode();
            },
            getNextCode () {
                let number = this.item.seedNumber;
                let qt_code = "QT";
                for(let i=0; i < this.areas.length; i++){
                    if(this.areas[i].categoryId == this.item.areaId){
                        if (this.areas[i].parentName != null && this.areas[i].parentName != '') {
                            qt_code += '-' + this.areas[i].parentName
                        } else {
                            let area_code = this.areas[i].categoryCode
                            qt_code += '-' + area_code.replace("KHU", "");
                        }
                        break;
                    }
                }

                if(qt_code != "" && number != ''){
                    qt_code += '-K-';
                    let autoIncreaseType= "PWH-"+qt_code + number;
                    axios.get(
                        process.env.VUE_APP_API_URL +
                        //"/autoIncrease/getNextCode?type=PWH&prefix="+qt_code+"&numberZeroBeforeCodeNumberCode=1&suffix="
                        //linhdx sua -- so tang theo ma khu va so luong
                        "/autoIncrease/getNextCode?type="+autoIncreaseType+"&prefix="+qt_code+"&numberZeroBeforeCodeNumberCode=1&suffix="
                    ).then((data) => {
                            let code = data;
                            let currentNo = code.replace(qt_code, "");
                            if (number != '' && number != null) {
                                code = code.replace("K", number);
                            }
                            this.currentCode = code;
                            this.item = Object.assign({}, this.item, {"code": code, currentNo: currentNo, "autoIncreaseType": autoIncreaseType})
                        });
                }
            },

        },
        created() {
        },
    };
</script>
